import { createSlice } from '@reduxjs/toolkit';

import { RootState } from 'modules/store';

import { PayoutsOnboardingState } from './payoutsOnboarding.types';
import {
  createOnboardingEnrollment,
  downloadPostmanCollection,
  getOnboardingAssets,
  getOnboardingEnrollment,
  getOnboardingQuestions,
} from './payoutsOnboarding.actions';

const initialState: PayoutsOnboardingState = {
  enrollment: null,
  enrollmentNotFound: false,
  isFetchingEnrollment: false,
  isEnrolling: false,

  questions: [],
  isFetchingQuestions: false,

  charts: [],
  docLinks: [],
  isFetchingAssets: false,
  isDownloadingPostmanCollection: false,
};

const payoutsOnboardingSlice = createSlice({
  name: 'payoutsOnboarding',
  initialState,
  reducers: {},
  extraReducers: builder => {
    // GET QUESTIONS
    builder.addCase(getOnboardingQuestions.pending, state => {
      state.isFetchingQuestions = true;
    });
    builder.addCase(getOnboardingQuestions.fulfilled, (state, { payload }) => {
      state.isFetchingQuestions = false;
      state.questions = payload || [];
    });
    builder.addCase(getOnboardingQuestions.rejected, state => {
      state.isFetchingQuestions = false;
    });

    // GET ENROLLMENT
    builder.addCase(getOnboardingEnrollment.pending, state => {
      state.isFetchingEnrollment = true;
    });
    builder.addCase(getOnboardingEnrollment.fulfilled, (state, { payload }) => {
      state.isFetchingEnrollment = false;
      state.enrollmentNotFound = false;
      state.enrollment = payload;
    });
    builder.addCase(getOnboardingEnrollment.rejected, (state, { payload }) => {
      state.isFetchingEnrollment = false;

      if (payload && 'notFound' in payload) {
        state.enrollmentNotFound = true;
        state.enrollment = null;
      }
    });

    // CREATE ENROLLMENT
    builder.addCase(createOnboardingEnrollment.pending, state => {
      state.isEnrolling = true;
    });
    builder.addCase(
      createOnboardingEnrollment.fulfilled,
      (state, { payload }) => {
        state.isEnrolling = false;
        state.enrollment = payload;
        state.enrollmentNotFound = false;
      },
    );
    builder.addCase(createOnboardingEnrollment.rejected, state => {
      state.isEnrolling = false;
    });

    // GET ASSETS (charts + doc links)
    builder.addCase(getOnboardingAssets.pending, state => {
      state.isFetchingAssets = true;
    });
    builder.addCase(getOnboardingAssets.fulfilled, (state, { payload }) => {
      state.isFetchingAssets = false;
      state.charts = payload.charts;
      state.docLinks = payload.docLinks;
    });
    builder.addCase(getOnboardingAssets.rejected, state => {
      state.isFetchingAssets = false;
    });

    // DOWNLOAD POSTMAN COLLECTION
    builder.addCase(downloadPostmanCollection.pending, state => {
      state.isDownloadingPostmanCollection = true;
    });
    builder.addCase(downloadPostmanCollection.fulfilled, state => {
      state.isDownloadingPostmanCollection = false;
    });
    builder.addCase(downloadPostmanCollection.rejected, state => {
      state.isDownloadingPostmanCollection = false;
    });
  },
});

export default payoutsOnboardingSlice.reducer;
export const selectPayoutsOnboarding = (state: RootState) =>
  state.root.payoutsOnboarding;
